import { Wrapper } from './Wrapper/Wrapper';

export const UiAccountSelectionView = {
  Wrapper,
};
